<!-- @format -->

<div
	class="product-card-wrapper hmf-grid hmf-span-12"
	[class]="{
		'hmf-mb-s': !isSponsored || !showNewSponsoredLabel,
		'hmf-mb-0': (isSponsored || isNikeExclusive) && showNewSponsoredLabel,
		disabled: isDisabled
	}">
	<div class="product-card-badge hmf-span-10">
		@if (badge()) {
			<hmf-badge [badgeName]="badge()" />
		} @else if (customBadge()) {
			<hmf-badge
				ngSkipHydration
				[style]="{
					background: 'var(' + customBadge().background + ')',
  					color: 'var(' + customBadge().textColor + ')'
				}"
				[badgeName]="customBadge().text">
			</hmf-badge>
		}
	</div>
	<div
		id="product-card"
		class="product-card-content hmf-span-12">
		<div class="inner-wrapper hmf-pb-xxs">
			<!-- This will be switched out for the product image component -->
			<div class="product-card-image hmf-mt-xxs hmf-mb-xs">
				<a
					role="button"
					class="image"
					tabindex="-1"
					aria-hidden="true"
					[href]="isDisabled ? 'javascript:void(0)' : updatedAssetSeoUrl"
					[class.disabled]="isDisabled"
					[title]="title"
					(click)="productCardClicked($event)">
					<span class="product-image-span hmf-display-flex hmf-justify-content-center">
						<homefield-product-image
							#productCardImage
							[imageUrl]="imageUrl"
							[ecode]="ecode"
							[defaultColor]="colors && colors.length > 0 ? colors[0] : null"
							[productName]="title"
							[selectedSwatchColor]="selectedSwatchColor"
							[isLCPImage]="isLCPImage"
							[isNgOptimizedImageSupported]="
								isNgOptimizedImageSupported
							"></homefield-product-image>
					</span>
				</a>
			</div>

			<!-- Switch to product-swatch component -->
			<div class="swatches-container hmf-mb-xs">
				@if (imageSwatchesEnabled()) {
					<plp-components-product-card-image-swatches
						[colors]="colors"
						[ecode]="ecode"
						[assetSeoUrl]="pdpUrl"
						[isLazy]="!isLCPImage"
						(selectedSwatchColorChange)="colorSwatchChanged($event)"
						(extraColorsClick)="productCardClicked($event)">
					</plp-components-product-card-image-swatches>
				} @else {
					<plp-components-product-card-color-swatches
						[colors]="colors"
						[ecode]="ecode"
						[assetSeoUrl]="pdpUrl"
						[isLazy]="!isLCPImage"
						(selectedSwatchColorChange)="colorSwatchChanged($event)"
						(extraColorsClick)="productCardClicked($event)">
					</plp-components-product-card-color-swatches>
				}
			</div>

			<a
				plp-components-product-title
				class="product-title-link hmf-subheader-m hmf-header-m-xs hmf-mb-xxs hmf-mb-m-0"
				[class]="{ 'favorite-product-title-link': inMauiList }"
				[linkURL]="updatedAssetSeoUrl"
				[title]="title"
				[ariaLabel]="productCardAriaLabel"
				(click)="productCardClicked($event)">
				{{ title }}
			</a>

			<ng-container *ngIf="inMauiList && !isUnavailable">
				<div
					class="hmf-mt-xxs hmf-mb-xs list-attribute-container"
					[class]="{ 'list-attribute-container--oos': isOOS }">
					<div
						*ngIf="favoritesAttributes.length"
						class="hmf-display-flex hmf-flex-wrap">
						<ng-container
							*ngFor="
								let attr of favoritesAttributes | slice: 0 : 3;
								let i = index;
								trackBy: trackByFn
							">
							<p
								class="favorite-attribute label-base-subtle hmf-subheader-s hmf-mb-0 hmf-display-flex">
								{{ attr.title }}: {{ attr.value
								}}<span
									*ngIf="
										i !== favoritesAttributes.length - 1 ||
										(favoritesAttributes.length <= 3 &&
											i === favoritesAttributes.length)
									"
									>,&nbsp;</span
								>
							</p>
						</ng-container>
						<p
							*ngIf="favoritesAttributes.length > 3"
							class="favorite-attribute label-base-subtle hmf-subheader-s"
							(click)="openAttributesPanel(true)">
							<span class="hmf-text-decoration-underline">View all details</span>
						</p>
					</div>
				</div>
			</ng-container>

			@if (isOOS && !isUnavailable) {
				<div
					class="oos-container"
					[class]="{ 'hmf-mb-m': sharedList() }">
					<p class="label-negative hmf-mb-0">Sorry, this item is out of stock.</p>
					@if (!sharedList()) {
						<p
							class="hmf-mb-0 underline"
							(click)="ecodeSelectedEmitter()">
							Shop Similar
						</p>
					}
				</div>
			}

			<ng-container *ngIf="isUnavailable">
				<p class="label-negative product-unavailable">
					<homefield-icon
						width="20px"
						name="alert-info-filled"
						class="unavailable-icon"
						fill="var(--hmf-fill-negative)"></homefield-icon>
					Product details failed to load
				</p>
			</ng-container>

			<a
				role="button"
				class="image"
				tabindex="-1"
				aria-hidden="true"
				[href]="isDisabled ? 'javascript:void(0)' : updatedAssetSeoUrl"
				[class.disabled]="isDisabled"
				[title]="title"
				(click)="productCardClicked($event)">
				<!-- Product price, price range, was price ( see price in cart )-->
				<div
					class="product-pricing hmf-mb-xs"
					*ngIf="!isUnavailable && !isOOS">
					<homefield-price
						[pricingInfo]="prices"
						[isSeePriceInCart]="mapPriceIndicator === 1"
						[isClearance]="priceIndicator === 0"></homefield-price>
					<homefield-strikethrough-price
						[pricingInfo]="prices"
						[isClearance]="priceIndicator === 0"></homefield-strikethrough-price>
				</div>

				<!-- Customer rating -->

				<div
					*ngIf="showCustomerRating"
					class="rating-container">
					<homefield-star-ratings
						[ratingCount]="ratingCount"
						[ratingValue]="ratingValue"
						[showCustomerRating]="showCustomerRating && !isSponsored">
					</homefield-star-ratings>
				</div>

				<!-- Promotion Message -->
				<div
					class="hmf-mb-xxs"
					[class]="location !== FavoritesLocationEnum.FAVORITES ? 'promo-message' : ''">
					<plp-components-promotion *ngIf="promo">
						{{ promo }}
					</plp-components-promotion>
				</div>

				<hr class="divider hmf-m-0" />

				<!-- availability component -->
				<plp-components-availability
					*ngIf="productAvailabilityData && availabilityOnProductCardsEnabled"
					[productAvailabilityData]="productAvailabilityData"
					[selectedStoreName]="selectedStoreName"
					[isOOS]="isOOS"
					[isComingSoon]="isComingSoon"></plp-components-availability>
			</a>
			<div
				*ngIf="!productAvailabilityData && availabilityOnProductCardsEnabled"
				class="hmf-my-xxs availability-loader"></div>

			@if (!isNikeExclusive) {
				<div
					class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
					@if (isComingSoon) {
						<button
							hmf-button
							class="hmf-px-0 hmf-py-0"
							aria-label="Learn More"
							[label]="'Learn More'"
							[size]="'medium'"
							[text]="'Learn More'"
							[variant]="'secondary'"
							(click)="productCardClicked()"></button>
					} @else {
						@if (isOOS || isUnavailable) {
							<p class="hmf-label-l out-of-stock hmf-mb-xxxs">OUT OF STOCK</p>
						} @else if (productQuickViewEnabled) {
							<button
								hmf-button
								id="add-to-cart-button"
								class="hmf-px-0 hmf-py-0"
								[class]="{ 'hmf-px-xs hmf-px-sm-0': chainAbbr === 'pl' }"
								aria-label="Add To Cart"
								[disabled]="isDisabled"
								[icon]="'order-cart-standard'"
								[label]="'Add To Cart'"
								[loading]="false"
								[size]="'medium'"
								[text]="'Add To Cart'"
								[variant]="'secondary'"
								(click)="openQuickview()"></button>
						}
					}
				</div>
			} @else {
				<div
					class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
					<a
						homefield-button
						class="hmf-mx-xxxs hmf-pb-xxxs hmf-bt-xxs"
						variant="tertiary"
						[href]="learnMoreUrl">
						Learn More
					</a>
				</div>
			}
			<!-- Compare checkbox -->
			@if (compareCheckboxEnabled) {
				<div class="compare-checkbox-container hmf-display-flex hmf-justify-content-center">
					<plp-components-compare-checkbox
						class="hmf-display-flex hmf-justify-content-center"
						[checked]="selectedForCompare"
						(check)="handleCompareSelection($event)" />
				</div>
			}
		</div>
	</div>
	<!-- end product card div-->

	<div
		*ngIf="(isSponsored || isNikeExclusive) && showNewSponsoredLabel"
		class="sponsored hmf-legal-xs">
		Sponsored
	</div>
</div>
